export default {
  switchAccount: "Mudar de Conta",
  login: "Conectar-se",
  loginFirst: "Faça o login primeiro",
  start: "Começar",
  hasHistory: "Você já respondeu algumas das perguntas.",
  loadHistory: "Você gostaria de continuar?",
  cancel: "Não",
  confirm: "Sim",
  contact:
    "Deixe seus dados de contato para ter a chance de ganhar recompensas de bônus!",
  completed: "Você concluiu a pesquisa!",
  leaveMessage:
    "Deixe seus dados de contato para ter a chance de ganhar recompensas de bônus!",
  enterEmail: "Email:",
  enterPhone: "Telefone:",
  submit: "Enviar",
  leave: "Sair",
  submitted: "Enviado",
  thanks: "Obrigado!",
  opinion: "Qual a sua opinião?",
  prev: "Anterior",
  next: "Próximo",
  unlikely: "Muito improvável",
  likely: "Muito provável",
  claimYourRewards: "Você pode reivindicar suas recompensas.",
  rewardSent: "Recompensas enviadas.",
  checkInGame: "Reivindique-os no jogo.",
  copy: "Copiar",
  copied: "Copiado!",
  selectTips: "Por favor, selecione a melhor resposta.",
  multipleTips: "Você pode selecionar várias respostas.",
  leastChoose: "Selecione até xxx respostas",
  maxChoose: "Selecione pelo menos xxx respostas.",
  mustAnswer: "Responda a pergunta atual primeiro.",
  mustWrite: "Por favor, escreva alguma coisa.",
  checkEmail: "Por favor insira um endereço de e-mail válido.",
  checkPhone: "Por favor insira um número de telefone válido.",
  isAnswer: "Você já fez a pesquisa.",
  unStart: "Evento não disponível",
  end: "Evento acabou",
  server: "Selecione seu servidor",
  role: "Selecione seu personagem",
  common: "O sistema está ocupado. Tente mais tarde.",
  title: "Questionário",
  titleAward: "Pesquisa",
  leastWord: "Insira pelo menos xxx caracteres.",
  maxWord: "Limite de caractères (xxx) dépassée !",
  singleChoose: "Resposta única",
  multiChoose: "Resposta Múltipla",
  matrix: "Questão Matriz",
  score: "Avaliação",
  textLimit: "(caracteres xx-aaa)",
  coverGiftTitle: "Complete a Pesquisa para Reivindicar Presente",
  "-20001": "Não conectado",
  "-20002": "Parâmetros obrigatórios ausentes",
  "-20003": "Questionário não encontrado",
  "-20004": "Configuração do questionário em andamento",
  "-20005": "Questionário parado",
  "-20006": "Evento do questionário não iniciado",
  "-20007": "Evento do questionário encerrado",
  "-20008": "Já respondido",
  "-20010": "Distribuição de recompensa falhou",
  "-20011": "Recompensa já distribuída para este questionário",
  "-20012": "Ainda não respondido",
  "-20016": "ID do jogo inválido",
};
